module.exports = __webpack_public_path__ + "img/ms-mcia-logo.00290ddf.png";